import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { ApiService } from '../../../../core/services/ApiService';
import { TransactionsStore } from '../stores/TransactionsStore';
import { ITransaction } from '../interfaces/ITransaction';
import { map } from 'rxjs/operators';
import { CartStore } from '../../../cart/core/stores/CartStore';
import { ICart } from '../../../cart/core/interfaces/ICart';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {

  private readonly _basePath = '/transactions';
  private readonly _apiService = inject(ApiService);
  private readonly _transactionsStore = inject(TransactionsStore);
  private readonly _cartStore = inject(CartStore);

  public getTransactions(showId?: number): Observable<IResponse<ITransaction[]>> {
    let httpParams = new HttpParams();

    if (showId) {
      httpParams = httpParams.append('showId', showId);
    }

    return this._apiService.get(`${this._basePath}/positions`, httpParams)
      .pipe(
        map((res: IResponse<ITransaction[]>) => {
          res.data = res.data.sortByKey('createdDate', 'desc');

          return res;
        }),
        tap(res => this._transactionsStore.selectedShowTransactions.set(res.data))
      );
  }

  public assignCustomerToTransaction(customerId: number, transactionId: number): Observable<IResponse<ICart>> {
    return this._apiService.put(`${this._basePath}/${transactionId}/assign-customer`, { customerId });
  }

  public generateInvoice(transactionId: number, isLast = false): Observable<IResponse<{ base64Content: string; }>> {
    return this._apiService.post(`${this._basePath}/generate-invoice`, { transactionId, isLast });
  }
}
